import React, {useEffect, useState} from 'react';
import {Pagination, Table} from "react-bootstrap";
import {SortDown, SortUp} from "./Font";
import {useSortBy, useTable, useAsyncDebounce, usePagination} from "react-table";
import {Form } from 'react-bootstrap';
import {Loading, SearchInput} from "./Components";
import {keyPressNavigate} from "../commons/Utils";
import {useHistory, useLocation} from "react-router-dom";

export type DataProvider = (pageIndex: number, pageSize: number, query?: string) => void;

type ReactTableProps = {
    columns: [],
    data?: Array<any>,
    emptyMsg?: string,
    onClick?: ()=>void,
    rowProps?: {},
    beforeRow?: any,
    afterRow?: any,
    globalSearch?: boolean,
    dataProvider?: DataProvider,
    isLoading?: boolean,
    pageCount?: number,
    totalCount?: number,
    startPageSize?: number,
    showIndex?: boolean,
    search?: boolean,
    serverSort: ()=>void,
    classes?: string
}

export const OrdinalColumn = { Header: 'Lp.', id: 'ordinal' , filterable: false,
    Cell: (data) => {
        let ps = data.state.pageSize;
        let start = ps ? data.state.pageIndex * ps : 0;
        return start + data.row.index + 1;
    }
};

const PaginationOptions = [20, 50, 100];

const DATA_IDX = 'data-idx';

const ReactTable = (tableProps: ReactTableProps) => {

    const plugins = [];
    const data = tableProps.data || [];

    const location = useLocation();
    const history = useHistory();

    const DefaultState = {
        query: '',
        pageSize: tableProps.startPageSize || ReactTable.DefaultPageSize,
        pageIndex: 0,
        sort: null
    };

    /** odczytujemy stan tabelki (filtr, strona, rozmiar, sortowanie) z query stringa URL **/
    const parseTableParams = (search) => {
        const p = new URLSearchParams(search);
        const page = parseInt(p.get('page'), 10);
        const size = parseInt(p.get('size'), 10);
        const sortId = p.get('sort');
        return {
            query: p.get('q') || '',
            pageIndex: page > 0 ? page - 1 : DefaultState.pageIndex,
            pageSize: size > 0 ? size : DefaultState.pageSize,
            sort: sortId ? {id: sortId, desc: p.get('dir') === 'desc'} : null,
        };
    };

    const initialParams = parseTableParams(location.search);

    const [query, setQuery] = useState(initialParams.query);
    const [srt, setSrt] = useState(initialParams.sort);
    let options = {columns: tableProps.columns, data};

    /** żeby sprawdzić czy kolumna będzie sortowana programowo **/
    let colMap = {};
    let filterColumns = {};
    tableProps.columns.forEach(c=>{
        colMap[c.accessor] = c;
        if (typeof c.filterColumn === 'function') {
            filterColumns[c.Header] = c.filterColumn;
        }
        //sortujemy po stronie serwera!!!
        // if (!c.disableSortBy) {
        //     console.log('c sorttype: ', c.sortType);
        //     const c = (rowA, rowB, columnId: string, desc: boolean) => {
        //
        //     }
            // "impel10".localeCompare("impel11", undefined,  {
            //     numeric: true,
            //     sensitivity: 'base'
            // });
        // }
    });

    /** sortowanie odtworzone z URL nie ma baseSort - uzupełniamy z definicji kolumny **/
    if (srt && srt.baseSort === undefined && colMap[srt.id]) {
        const h = colMap[srt.id];
        srt.baseSort = typeof h.baseSort === 'undefined' ? true : h.baseSort;
    }

    // const serverSort = isUndef(tableProps.serverSort) ? false : tableProps.serverSort;
    // const search = isUndef(tableProps.search) ? true : tableProps.search;
    // const filter = isUndef(tableProps.filter) ? false : tableProps.filter;
    const _pageCount = tableProps.pageCount ? tableProps.pageCount : Math.ceil(tableProps.totalCount/(initialParams.pageSize || DefaultState.pageSize));

    plugins.push(useSortBy);
    if (tableProps.dataProvider) {
        plugins.push(usePagination);
        options.initialState = {
            pageIndex: initialParams.pageIndex || DefaultState.pageIndex,
            pageSize: initialParams.pageSize || DefaultState.pageSize
        };
        options.manualPagination = true;
        options.autoResetPage = false;
        options.autoResetSortBy = false;
        options.pageCount = _pageCount;
        if (tableProps.serverSort) options.manualSortBy = true;
    }

    const instance = useTable(options, ...plugins);
    // eslint-disable-next-line
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, state, setGlobalFilter, page, pageOptions, pageCount,
        gotoPage, setPageSize,
        state: {pageIndex, pageSize = tableProps.startPageSize || ReactTable.DefaultPageSize }, //, sortBy
    } = instance;

    useEffect(() => {
        if (tableProps.dataProvider) {
            // let sort = tableProps.serverSort ? sortBy[0] : null;
            // // console.log('tableProps.serverSort: ', tableProps.serverSort)
            // console.log('sortBy:' , sort)
            // console.log('state sort:' , srt)
            // if (sort) {
            //     let h = colMap[sort.id];
            //     sort.baseSort = typeof h.baseSort === 'undefined' ? true : h.baseSort;
            // }
            tableProps.dataProvider({pageIndex, pageSize, query, sort: srt});
        }
    }, [pageIndex, pageSize])

    const _rowProps = (data) => tableProps.rowProps ? tableProps.rowProps(data) : {};
    const _beforeRow = (data) => tableProps.beforeRow ? tableProps.beforeRow(data) : null;
    const _afterRow = (data) => tableProps.afterRow ? tableProps.afterRow(data) : null;

    const onSelected = (row, event) => {
        try {
            const idx = event.target.getAttribute(DATA_IDX);
            const cell = row.cells[idx];
            const val = cell.value;
            if (val) {
                const f = filterColumns[cell.column.Header];
                //znaleziony funckcje filtrująca
                if (f) {
                    //kliknieto w komórkę filtrująca, ignorujemy listener kliknięcia na wiersz
                    //jeśli jest
                    onSearch(f(val));
                    event.preventDefault();
                    return;
                }
            }
        } catch (e) {
            console.log('error while checking filterable column' + e);
        }
        if (tableProps.onClick) tableProps.onClick(row.original);
    }

    /**
     * zapisujemy obecne ustawienia tabelki (filtr, strona, rozmiar, sortowanie) w query stringu URL.
     * Wartości równe domyślnym usuwamy z URL, żeby adres pozostał czysty.
     * @param updates obiekt z parami nazwa-wartość parametrów query do ustawienia/usunięcia
     */
    const updateTableUrl = (updates) => {
        const p = new URLSearchParams(location.search);
        Object.entries(updates).forEach(([k, v]) => {
            if (v === null || v === undefined || v === '') p.delete(k);
            else p.set(k, v);
        });
        const s = p.toString();
        history.replace({
            pathname: location.pathname,
            search: s ? `?${s}` : ''
        });
    }

    const onSearch = (value?: string) => {
        if (query === value) return;
        // zmiana filtra resetuje stronę na pierwszą - jeden zapis do URL (q + reset strony)
        updateTableUrl({q: value || null, page: null});
        setQuery(value);
        gotoPage(0);
        // setCurrentPageSize(pageSize);
        tableProps.dataProvider({pageIndex: 0, pageSize: pageSize, query: value});
    }

    const onSort = (column) => {
        setTimeout(()=>{
            let _srt = null;
            if (column.isSorted) {
                let h = colMap[column.id];
                _srt = {id: column.id, desc: column.isSortedDesc, baseSort: typeof h.baseSort === 'undefined' ? true : h.baseSort};
                setSrt(_srt);
            }
            setSrt(_srt);
            updateTableUrl({sort: _srt ? _srt.id : null, dir: _srt ? (_srt.desc ? 'desc' : 'asc') : null});
            tableProps.dataProvider({pageIndex, pageSize, query, sort: _srt});
        }, 100);
    }

    const setCurrentPage = (p: number) => {
        updateTableUrl({page: p > 0 ? p + 1 : null});
        gotoPage(p);
    }

    const setCurrentPageSize = (size: number) => {
        updateTableUrl({size: size !== DefaultState.pageSize ? size : null});
        setPageSize(size);
    }

    let tbody;
    if (tableProps.isLoading) {
        tbody = <tr><td colSpan={tableProps.columns.length}><Loading/></td></tr>
    } else if (!data || !data.length) {
        tbody = <tr><td colSpan={tableProps.columns.length} className="empty-state-cell">
            <div className="empty-state">
                <i className="fas fa-inbox empty-state-icon"/>
                <div className="empty-state-text">{tableProps.emptyMsg || 'Brak danych'}</div>
            </div>
        </td></tr>;
    } else {
        const isEmpty = (v) => v === null || v === undefined || v === '';
        tbody = rows.map(
            (row, i) => {
                prepareRow(row);
                return <React.Fragment key={row.id}>
                    {_beforeRow(row.original)}
                    <tr {...row.getRowProps(_rowProps(row.original))} tabIndex={tableProps.onClick ? 0 : -1}
                        onClick={(event)=>onSelected(row, event)} onKeyPress={(e)=>
                            keyPressNavigate(e, (event, data) => event.target.tagName === 'TR', row.original, onSelected)}>
                        {
                            row.cells.map((cell, cellIdx) => {
                                const cn = `${cell.column.className ? cell.column.className : cell.column.id}${filterColumns[cell.column.Header] ? ' filterable' : ''}`
                                const hasCustomCell = typeof cell.column.Cell === 'function' && cell.column.Cell.name !== 'defaultRenderer';
                                const showDash = !hasCustomCell && isEmpty(cell.value);
                                const titleAttr = isEmpty(cell.value) ? undefined : String(cell.value);
                                return <td {...cell.getCellProps({className: cn})} data-idx={cellIdx} title={titleAttr} >
                                    {showDash ? <span className="empty-cell">—</span> : cell.render('Cell')}
                                </td>
                            })
                        }
                    </tr>
                    {_afterRow(row.original)}
                </React.Fragment>
            }
        );
    }

    let paginator = tableProps.dataProvider ? (
        <div className="table-footer">
            <div className="table-footer-pagination">
                {pageCount > 1 && <Paginator count={pageCount} currentPage={pageIndex} setPage={(p) => setCurrentPage(p)} />}
            </div>
            <div className="table-footer-meta">
                {pageCount > 0 && <span>Strona <strong>{pageIndex + 1}</strong> z <strong>{pageCount}</strong></span>}
                {typeof tableProps.totalCount === 'number' && pageCount > 0 && <span className="dot-sep">·</span>}
                {typeof tableProps.totalCount === 'number' && (
                    <span>{tableProps.totalCount} {tableProps.totalCount === 1 ? 'wynik' : 'wyników'}</span>
                )}
            </div>
            <div className="table-footer-pagesize">
                <label htmlFor="pageSizeSelect">Pokaż:</label>
                <Form.Control id="pageSizeSelect" as="select" size="sm" custom value={pageSize}
                              onChange={e => setCurrentPageSize(Number(e.target.value))}>
                    {PaginationOptions.map((s) => <option key={s} value={s}>{s}</option>)}
                </Form.Control>
            </div>
        </div>
    ) : null;

    return <>
        {/*<pre>*/}
        {/*    <code>*/}
        {/*      {JSON.stringify({pageIndex, pageSize, pageCount}, null, 2)}*/}
        {/*    </code>*/}
        {/*</pre>*/}

        {tableProps.search ?
            <div className="table-toolbar">
                <Search change={onSearch} initial={query} />
            </div>
            : null }

        {tableProps.globalSearch ?
            <GlobalFilter globalFilter={state.globalFilter} setGlobalFilter={setGlobalFilter}/> : null }

        <Table className={tableProps.classes} responsive striped bordered hover size="sm" {...getTableProps()}>
            <thead>
            {
                headerGroups.map((hg) => (
                    <tr {...hg.getHeaderGroupProps()}>
                        {
                            hg.headers.map(column => {
                                const sortable = !column.disableSortBy;
                                const baseProps = sortable
                                    ? column.getHeaderProps(column.getSortByToggleProps())
                                    : column.getHeaderProps();
                                return (
                                    <th {...baseProps}
                                        className={`${column.className ? column.className : ''} ${column.id} ${sortable ? '' : 'no-sort'}`}
                                        onClick={sortable ? (e) => {
                                            column.getHeaderProps(column.getSortByToggleProps()).onClick(e);
                                            onSort(column);
                                        } : undefined}
                                    >
                                        {column.render('Header')}
                                        {sortable && <span>
                                            {srt && srt.id === column.id ? srt.desc ? <SortDown /> : <SortUp /> : ''}
                                        </span>}
                                    </th>
                                );
                            })
                        }
                    </tr>
                ))
            }
            </thead>
            <tbody {...getTableBodyProps()}>
            {tbody}
            </tbody>
        </Table>
        {paginator}
    </>;
}

const Search = ({change, initial}: {change: (?string)=>void, initial?: string}) => {

    const onChange = useAsyncDebounce(value => {
        change(value)
    }, 1000);

    return <SearchInput className="filter" onSearch={(value, instant)=> instant ? change(value) : onChange(value)} initial={initial} minLength={2}/>
}

const GlobalFilter = ({ globalFilter, setGlobalFilter}) => {
    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined)
    }, 1000);

    return <SearchInput className="filter" onSearch={onChange} minLength={2}/>

}

const Paginator = ({count, currentPage, setPage}: {count: number, currentPage: number, setPage: (page: number)=>void}) => {
    if (count <= 1) return null;

    const sidePages = 2;
    const last = count - 1;

    let low = Math.max(1, currentPage - sidePages);
    let high = Math.min(last - 1, currentPage + sidePages);

    if (currentPage - sidePages <= 1) high = Math.min(last - 1, 1 + sidePages * 2);
    if (currentPage + sidePages >= last - 1) low = Math.max(1, last - 1 - sidePages * 2);

    const middle = [];
    for (let i = low; i <= high; i++) middle.push(i);

    const showLeftEllipsis = low > 1;
    const showRightEllipsis = high < last - 1;

    const item = (p) => (
        <Pagination.Item key={p} onClick={() => setPage(p)} active={p === currentPage}>{p + 1}</Pagination.Item>
    );

    return <Pagination>
        <Pagination.Prev disabled={currentPage === 0} onClick={() => setPage(currentPage - 1)}/>
        {item(0)}
        {showLeftEllipsis && <Pagination.Ellipsis disabled />}
        {middle.map(item)}
        {showRightEllipsis && <Pagination.Ellipsis disabled />}
        {last > 0 && item(last)}
        <Pagination.Next disabled={currentPage === last} onClick={() => setPage(currentPage + 1)}/>
    </Pagination>;
}

ReactTable.DefaultPageSize = PaginationOptions[0];
// export default React.memo(ReactTable);
export default ReactTable;